import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController, ToastController} from '@ionic/angular';
import {AggregatedAreaConfig} from 'src/app/360-evaluation/_interfaces/area-config.interface';
import {AggregatedHeadEvaluated, HeadEvaluated} from 'src/app/head-evaluation/_interfaces/head-evaluated.interface';
import {HeadEvaluationStatus} from 'src/app/head-evaluation/_interfaces/head-evaluation-status';
import {BaseClass} from 'src/app/shared/classes/base';
import {
    HeadEditFinalAverageComponent
} from 'src/app/shared/components/head-evaluation/head-edit-final-average/head-edit-final-average.component';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {
    ReopenHeadConfirmComponent
} from '../../../shared/components/head-evaluation/reopen-head-confirm/reopen-head-confirm.component';
import {ReviewEvaluationsModal} from '../../../shared/components/review-evaluations/review-evaluations.modal';
import {AuthService} from '../../../shared/services/auth.service';
import {HeadEvaluationService} from '../../head-evaluation.service';

@Component({
    selector: 'app-subordinate-user-list',
    templateUrl: './subordinate-user-list.component.html',
    styleUrls: ['./subordinate-user-list.component.scss'],
})
export class SubordinateUserListComponent extends BaseClass implements OnInit {
    public readonly HeadEvaluationStatus = HeadEvaluationStatus;

    @Input() cycleParticipantId: number = null;
    @Input() userEvaluation: HeadEvaluated = null;
    @Input() colSize: number = null;
    @Input() colSizeToAreas: number = null;
    @Input() areas: AggregatedAreaConfig[] = [];
    @Input() level: number = 0;
    @Input() cycleId: number = null;
    @Output() getEvaluations = new EventEmitter<string>();

    public isRhOrAdmin: boolean = false;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        protected _modalController: ModalController,
        private _evaluationService: HeadEvaluationService,
        private _authService: AuthService,
    ) {
        super(_toastController, _translationService);
        let roles = this._authService.getUserRoles();
        this.isRhOrAdmin = roles && (roles.includes('HR') || roles.includes('Administrator'));
    }

    ngOnInit() {
    }

    public async reopenAndEditFinalAverage(evaluatedUser: HeadEvaluated) {
        const modal = await this._modalController.create(
            {
                component: ReopenHeadConfirmComponent,
                cssClass: 'head-reopen-confirmation',
                componentProps: {
                    'userEvaluation': evaluatedUser
                },
            }
        );

        modal.onDidDismiss().then(async (data) => {
            if (data.data) {
                let evaluation: AggregatedHeadEvaluated = {
                    cycleParticipantId: this.cycleParticipantId,
                    subjectUserId: evaluatedUser.userId,
                    initialFinalEvaluation: null,
                    finalEvaluation: null,
                };

                await this._evaluationService.reopenHeadEvaluation(evaluation).subscribe(
                    async () => {
                        this.notifySuccess('headEvaluation.statusUpdateSuccessfully');
                        this.userEvaluation.status = HeadEvaluationStatus.NotSent;
                        await this.editFinalAverage(evaluatedUser);
                    },
                    (err) => {
                        this.notifyError(err);
                    }
                );
            }
        });

        return modal.present();
    }


    public async editFinalAverage(evaluatedUser: HeadEvaluated) {
        const modal = await this._modalController.create(
            {
                component: HeadEditFinalAverageComponent,
                cssClass: 'head-average-edit',
                componentProps: {
                    'userEvaluation': evaluatedUser
                },
            }
        );

        modal.onDidDismiss().then(async (data) => {
            if (data.data) {
                if(Number(data.data) > 5)
                {
                    await this.notify(this._translationService.getTranslation('headEvaluation.finalEvaluationExceededMax'), 'danger');
                    return;
                }
                evaluatedUser.finalEvaluation = data.data;

                let evaluation: AggregatedHeadEvaluated = {
                    cycleParticipantId: this.cycleParticipantId,
                    subjectUserId: evaluatedUser.userId,
                    initialFinalEvaluation: evaluatedUser.initialFinalEvaluation,
                    finalEvaluation: evaluatedUser.finalEvaluation,
                };

                await this._evaluationService.saveHeadEvaluation(evaluation).subscribe(
                    async () => {
                        this.notifySuccess('headEvaluation.sentSuccessfully');
                        this.userEvaluation.status = HeadEvaluationStatus.Sent;
                    },
                    (err) => {
                        this.notifyError(err);
                    }
                );
            }
        });

        return modal.present();
    }


    public async view360Review(): Promise<void> {
        const modal = await this._modalController.create({
            component: ReviewEvaluationsModal,
            cssClass: 'new-goals-input round bigger-modal',
            componentProps: {
                'cycleId': this.cycleId,
                'userId': this.userEvaluation.userId,
                'getManagerEvaluation': true
            }
        });

        return await modal.present();
    }
}
